import { defineStore } from 'pinia'
import { ref, watchEffect, reactive, watch } from 'vue'
import { setBodyPrimaryColor } from '@/utils/format'
import { useDark, usePreferredDark } from '@vueuse/core'
import { VxeUI } from 'vxe-table'
export const useAppStore = defineStore('app', () => {
  const device = ref('')
  const drawerSize = ref('')
  const operateMinWith = ref('240')
  const waitAllOrderCount = ref(0) // 所有订单数
  const waitApprovalOrderCount = ref(0) // 待处理订单数
  const waitApprovalOrderTradingCount = ref(0) // 异常回调订单数
  const waitApprovalOrderFailureCount = ref(0) // 失败订单数
  const abnormalRechargeOrderCount = ref(0) // 异常到账充值订单数
  const config = reactive({
    weakness: false,
    grey: false,
    primaryColor: '#3b82f6',
    showTabs: true,
    darkMode: 'light',
    layout_side_width: 256,
    layout_side_collapsed_width: 80,
    layout_side_item_height: 48,
    show_watermark: true,
    side_mode: 'normal',
    // 页面过渡动画配置
    transition_type: 'slide'
  })

  const isDark = useDark({
    selector: 'html',
    attribute: 'class',
    valueDark: 'dark',
    valueLight: 'light'
  })

  const preferredDark = usePreferredDark()

  const toggleTheme = (darkMode) => {
    isDark.value = darkMode
  }

  watch(
    () => isDark.value,
    (val) => {
      if (val) {
        VxeUI.setTheme('dark')
      } else {
        VxeUI.setTheme('light')
      }
    }
  )

  const toggleWeakness = (e) => {
    config.weakness = e
  }

  const toggleGrey = (e) => {
    config.grey = e
  }

  const togglePrimaryColor = (e) => {
    config.primaryColor = e
  }

  const toggleTabs = (e) => {
    config.showTabs = e
  }

  const toggleDevice = (e) => {
    if (e === 'mobile') {
      drawerSize.value = '100%'
      operateMinWith.value = '80'
    } else {
      drawerSize.value = '800'
      operateMinWith.value = '240'
    }
    device.value = e
  }

  const toggleDarkMode = (e) => {
    config.darkMode = e
  }

  // 监听系统主题变化
  watchEffect(() => {
    if (config.darkMode === 'auto') {
      isDark.value = preferredDark.value
      return
    }
    isDark.value =  config.darkMode === 'dark'
  })

  const toggleConfigSideWidth = (e) => {
    config.layout_side_width = e
  }

  const toggleConfigSideCollapsedWidth = (e) => {
    config.layout_side_collapsed_width = e
  }

  const toggleConfigSideItemHeight = (e) => {
    config.layout_side_item_height = e
  }

  const toggleConfigWatermark = (e) => {
    config.show_watermark = e
  }

  const toggleSideMode = (e) => {
    config.side_mode = e
  }

  const toggleTransition = (e) => {
    config.transition_type = e
  }

  const setAllOrderCount = (count) => {
    waitAllOrderCount.value = count
  }
  
  const setWaitApprovalOrderCount = (count) => {
    waitApprovalOrderCount.value = count
  }

  const setWaitApprovalOrderTradingCount = (count) => {
    waitApprovalOrderTradingCount.value = count
  }

  const setWaitApprovalOrderFailureCount = (count) => {
    waitApprovalOrderFailureCount.value = count
  }

  const setAbnormalRechargeOrderCount = (count) => {
    abnormalRechargeOrderCount.value = count
  }

  const baseCoinfg = {
    weakness: false,
    grey: false,
    primaryColor: '#3b82f6',
    showTabs: true,
    darkMode: 'auto',
    layout_side_width: 256,
    layout_side_collapsed_width: 80,
    layout_side_item_height: 48,
    show_watermark: true,
    side_mode: 'normal',
    // 页面过渡动画配置
    transition_type: 'slide'
  }

  const resetConfig = () => {
    for (let baseCoinfgKey in baseCoinfg) {
      config[baseCoinfgKey] = baseCoinfg[baseCoinfgKey]
    }
  }

  // 监听色弱模式和灰色模式
  watchEffect(() => {
    document.documentElement.classList.toggle('html-weakenss', config.weakness)
    document.documentElement.classList.toggle('html-grey', config.grey)
  })

  // 监听主题色
  watchEffect(() => {
    setBodyPrimaryColor(config.primaryColor, isDark.value ? 'dark' : 'light')
  })

  return {
    isDark,
    device,
    drawerSize,
    operateMinWith,
    waitAllOrderCount,
    waitApprovalOrderCount,
    waitApprovalOrderTradingCount,
    waitApprovalOrderFailureCount,
    abnormalRechargeOrderCount,
    config,
    toggleTheme,
    toggleDevice,
    toggleWeakness,
    toggleGrey,
    togglePrimaryColor,
    toggleTabs,
    toggleDarkMode,
    toggleConfigSideWidth,
    toggleConfigSideCollapsedWidth,
    toggleConfigSideItemHeight,
    toggleConfigWatermark,
    toggleSideMode,
    toggleTransition,
    setAllOrderCount,
    setWaitApprovalOrderCount,
    setWaitApprovalOrderTradingCount,
    setWaitApprovalOrderFailureCount,
    setAbnormalRechargeOrderCount,
    resetConfig
  }
})
